module.exports = __webpack_public_path__ + "static/media/wolly-logo-updated.7b3e063d.png";